import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const AgriPromoterTargetList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteTarget } = useHttp();

  const deleteData = (agriPromoterTargetId) => {
    const input = {
      agriPromoterTargetId: agriPromoterTargetId,
    };
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this AgriPromoter Target detail?",
      onOk() {
        //console.log(agriPromoterTargetId);
        deleteTarget(
          {
            url: `/api/agripromotertarget/`,
            body: input,
            method: "DELETE",
          },
          (res) => {
            //console.log(res);
            toast.success("AgriPromoter Target Deleted ");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/agripromotertarget/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.docNo?.toLowerCase().includes(filetrtext) ||
        item?.employeeName?.toLowerCase().includes(filetrtext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const { sendRequest: getDetailView } = useHttp();

  const openModal = (id) => {
    if (id) {
      getDetailView(
        {
          url: `/api/agripromotertarget/?agriPromoterTargetId=${id}&orgId=${localStorage.getItem(
            "orgId"
          )}`,
        },
        (res) => {
          if (res) {
            setSelectedData(res);
          }
        }
      );
    }
    setIsModalOpen(true);
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Agri Promoter Target Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Doc No: {selectedData.docNo}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Target Date: {selectedData.createdDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">From Date : {selectedData.fromDate}</p>
              <p className="col-md-6">To Date : {selectedData.toDate}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                No Of Demo Tobe Established:{" "}
                {selectedData.noOfDemoTobeEstablished}
              </p>
              <p className="col-md-6">
                Procurement Officer : {selectedData.employeeName}
              </p>
            </div>
            <h5 className="card-title">Product Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Product Item Type</th>
                  <th>Product Item SubType</th>
                  <th>Product Name</th>

                  <th>Target</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productDetail &&
                  selectedData.productDetail.map((x, i) => (
                    <tr key={i}>
                      <td>{x.productTypeName}</td>
                      <td>{x.productSubTypeName}</td>
                      <td>{x.productName}</td>
                      <td>{x.targetQty}</td>
                      <td>{x.unitAbbreviation}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Field Demonstration Target Details{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add field demonstration Target
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered table-responsive text-center">
                        <thead>
                          <tr>
                            <th>Doc No</th>
                            <th>Target Date</th>
                            <th>From Date</th>

                            <th>To Date</th>
                            <th>No Of Demo Tobe Established</th>
                            <th>Procurement Officer </th>

                            <th>Status</th>
                            <th>View</th>
                            
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.docNo}</td>
                                <td>{x.createdDate}</td>
                                <td>{x.fromDate}</td>

                                <td>{x.toDate}</td>
                                <td>{x.noOfDemoTobeEstablished}</td>
                                <td>{x.employeeName}</td>

                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      openModal(x.agriPromoterTargetId)
                                    }
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                               
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      deleteData(x.agriPromoterTargetId);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgriPromoterTargetList;
